import React from 'react';
import styled from 'styled-components';
import { FiArrowLeft } from 'react-icons/fi';

const Container = styled.div`
  min-height: 100vh;
  background: #0a0a0f;
  color: rgba(255, 255, 255, 0.8);
  padding: 60px 24px;
`;

const Content = styled.div`
  max-width: 720px;
  margin: 0 auto;

  h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 8px;
  }

  .updated {
    font-size: 0.85rem;
    opacity: 0.4;
    margin-bottom: 40px;
  }

  h2 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #fff;
    margin: 32px 0 12px;
  }

  p, li {
    font-size: 0.95rem;
    line-height: 1.8;
    opacity: 0.7;
    margin-bottom: 12px;
  }

  ul {
    padding-left: 20px;
  }
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 32px;
  transition: color 0.2s;

  &:hover { color: #fff; }
`;

export default function TermsOfService() {
  return (
    <Container>
      <Content>
        <BackButton onClick={() => window.history.back()}>
          <FiArrowLeft /> Voltar
        </BackButton>

        <h1>Termos de Uso</h1>
        <p className="updated">Última atualização: 12 de maio de 2026</p>

        <h2>1. Aceitação dos Termos</h2>
        <p>
          Ao acessar e utilizar a plataforma Vidal ("Plataforma"), você concorda com estes Termos de Uso.
          Se você não concordar com qualquer parte destes termos, não utilize a Plataforma.
        </p>

        <h2>2. Descrição do Serviço</h2>
        <p>
          O Vidal é uma plataforma de inteligência fiscal que oferece ferramentas para:
        </p>
        <ul>
          <li>Gestão e análise de documentos fiscais (XMLs, SPEDs)</li>
          <li>Download automatizado de NFe via SEFAZ</li>
          <li>Monitoramento de notificações fiscais (eCAC, DEC-SP)</li>
          <li>Análise de conformidade tributária (Reforma Tributária)</li>
          <li>Gestão de certificados digitais</li>
          <li>Cálculo de créditos tributários</li>
        </ul>

        <h2>3. Cadastro e Conta</h2>
        <p>
          Para utilizar a Plataforma, você deve criar uma conta fornecendo informações verdadeiras e atualizadas.
          Você é responsável por manter a confidencialidade de suas credenciais de acesso.
        </p>

        <h2>4. Planos e Pagamento</h2>
        <p>
          A Plataforma oferece diferentes planos de assinatura. O período de trial gratuito é de 14 dias.
          Após o trial, é necessário assinar um plano para continuar utilizando os serviços.
          Os pagamentos são processados pela Asaas e seguem os termos do processador de pagamento.
        </p>

        <h2>5. Uso dos Dados</h2>
        <p>
          Os documentos fiscais e dados enviados à Plataforma são de propriedade exclusiva do usuário.
          O Vidal não compartilha dados fiscais com terceiros e utiliza criptografia para proteger as informações.
        </p>

        <h2>6. Certificados Digitais</h2>
        <p>
          Certificados digitais enviados à Plataforma são armazenados de forma segura e utilizados exclusivamente
          para realizar as automações solicitadas pelo usuário (download de XMLs, consultas à SEFAZ).
          O usuário é responsável por manter seus certificados válidos e atualizados.
        </p>

        <h2>7. Limitações de Responsabilidade</h2>
        <p>
          O Vidal não se responsabiliza por:
        </p>
        <ul>
          <li>Indisponibilidade de serviços externos (SEFAZ, eCAC, Receita Federal)</li>
          <li>Erros ou inconsistências nos dados fiscais fornecidos pelo usuário</li>
          <li>Decisões tomadas com base nas análises da Plataforma</li>
          <li>Perdas decorrentes de uso indevido das credenciais</li>
        </ul>

        <h2>8. Cancelamento</h2>
        <p>
          O usuário pode cancelar sua assinatura a qualquer momento. O acesso permanece ativo até o final
          do período pago. Após o cancelamento, os dados são mantidos por 90 dias e podem ser exportados.
        </p>

        <h2>9. Modificações</h2>
        <p>
          O Vidal reserva-se o direito de modificar estes termos a qualquer momento.
          Modificações significativas serão comunicadas por email.
        </p>

        <h2>10. Contato</h2>
        <p>
          Para dúvidas sobre estes termos, entre em contato pelo email: suporte@vidal-app.com
        </p>
      </Content>
    </Container>
  );
}
